import React from "react";
import { Col, Modal, Row } from "react-bootstrap";
import "./Modal.css";
// import icTitle from "../../assets/images/ic-group.svg";
// import msgIcon from "../../../assets/images/message-line.svg";

const ENGModalHeader = ({ icon = "", title }: { icon: any; title: any }) => {
  return (
    <Modal.Header
      closeButton
      closeVariant="white"
      style={{
        padding: "0.75rem",
        backgroundImage: `linear-gradient(to right, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0)), 
      linear-gradient(to bottom, #333333, #333333)`,
      }}
    >
      <Modal.Title
        style={{
          fontFamily: "Saira",
          fontSize: "18px",
          fontWeight: 500,
          width: "90%",
        }}
      >
        <Row>
          <Col xs={12} sm={12}>
            <img src={icon} /> &nbsp; {title}
          </Col>
          {/* <Col xs={10} sm={11}>
            {title}
          </Col> */}
        </Row>
      </Modal.Title>
    </Modal.Header>
  );
};

export default ENGModalHeader;
